<template>
  <div>
    <h2>
      Terms
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
    >
      <el-row>
        <el-col>
          <el-form-item>
            <el-input
              v-model="formData.terms"
              type="textarea"
              rows="8"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      isSaving: false
    }
  }
}
</script>
